import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.setErrorCode:
            return {
                ...state,
                code: action.payload.code
            };
        case ActionTypes.resetErrorCode:
            return {
                ...state,
                code: undefined
            };
        case ActionTypes.setHadPassengerNameError:
            return {
                ...state,
                hadPassengerNameError: true
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
